import React, { useEffect, useState } from 'react';
import "../../assets/styles/Search.css";
import Popup from "reactjs-popup";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import InfoUser from "../../components/Profile/InfoUser.js";
import DataConfirm from "../../components/Profile/DataConfirm.js";
import HtmlNote from "../../components/Profile/HtmlNote.js";
import Collapsible from "react-collapsible";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/helper/Loading.js";
import { config } from "../../config.js";
import { apiGetRequestHistory, apiCheckDataAccount, apiFormUpdateAccount, apiGetBanks } from "../../services/api.service.js";
import {
  Box,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import { AddPhotoAlternateOutlined, Close } from "@mui/icons-material";
import iconArrow from "../../icons/icon-arrow.png";
import iconSendMail from "../../icons/icon-send-mail.png";
import iconSendPhone from "../../icons/icon-send-phone.png";
import iconImage from "../../icons/icon-send-image.png";
import iconClose from "../../icons/icon-close.png";
import iconWarning from "../../icons/icon-warning.png";
import iconSuccess from "../../icons/icon-success.png";

function ChangeInfo() {
  const location = useLocation();
  const { userName, data, webSetting, typeModal } = location.state || {};
  const showOldContactFields = typeModal === "phone_number" || typeModal === "email";

  // mô tả file upload và số ảnh tối thiểu theo mục thông tin khách đang chọn (setup ở admin)
  const uploadSetting = webSetting?.upload_descriptions || {};
  const uploadConfig = uploadSetting.by_update_type?.[typeModal] || {};
  const uploadDescriptions = [];
  (uploadConfig.keys || []).forEach((key) => {
    const item = (uploadSetting.items || []).find((item) => item.key === key);
    if (item?.content) uploadDescriptions.push(item.content);
  });
  // chưa setup số ảnh tối thiểu thì bằng tổng số mô tả ảnh admin yêu cầu (không có mô tả thì tối thiểu 1)
  const minFiles = uploadConfig.min_files ?? (uploadDescriptions.length || 1);
  const [openResult, setOpenResult] = useState(false);
  const [checkConfirm, setCheckConfirm] = useState(false);
  const [isSendMail, setIsSendMail] = useState(true);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [previews, setPreviews] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [infoFileUpload, setInfoFileUpload] = useState("");
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [banks, setBanks] = useState([]); // danh sách ngân hàng cho khách chọn
  const originalDataUpdate = {
    name: "",
    province: "",
    bank_type_change: "",
    bank_code: "",
    bank_name: typeModal === "usdt" ? "USDT-TRC20" : "",
    bank_number: "",
    email: "",
    phone_number: "",
  };
  const originalDesChangeBank = {
    title_change_bank: "THAY ĐỔI THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Mới",
  };
  const originalDesChangeUsdt = {
    title_change_bank: "THAY ĐỔI THÔNG TIN VÍ",
    bank_name: "Hệ Ví Mới",
    bank_number: "Số Ví Mới",
  };
  const desBankNew = {
    title_change_bank: "THÊM THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Ngân Hàng Mới",
  };
  const desUsdtNew = {
    title_change_bank: "THÊM THÔNG TIN VÍ",
    bank_name: "Hệ Ví Mới",
    bank_number: "Số Ví Mới",
  };
  const desBankRemove = {
    title_change_bank: "XÓA SỐ TÀI KHOẢN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Cần Xóa",
    bank_number: "Số Tài Khoản Cần Xóa",
  };
  const desUsdtRemove = {
    title_change_bank: "XÓA SỐ TÀI KHOẢN VÍ",
    bank_name: "Hệ Ví Cần Xóa",
    bank_number: "Số Ví Cần Xóa",
  };
  const [desChangeBank, setDesChangeBank] = useState(originalDesChangeBank);
  const [desChangeUsdt, setDesChangeUsdt] = useState(originalDesChangeUsdt);
  const [dataUpdate, setDataUpdate] = useState(originalDataUpdate);
  const [timesCheckData, setTimesCheckData] = useState(0);
  const [dataCheck, setDataCheck] = useState({
    name: "",
    province: "",
    bank_code: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  });
  const [recentRequests, setRecentRequests] = useState((data?.recent_requests || []).slice(0, 2));
  const [submittedRequest, setSubmittedRequest] = useState(null);
  const [pollingChecks, setPollingChecks] = useState(0);
  const [isRefreshingRequest, setIsRefreshingRequest] = useState(false);
  const [requestRefreshMessage, setRequestRefreshMessage] = useState("");

  const [user, setUser] = useState({
    account: userName,
    update_type: "",
    status: "",
    auto_check: "",
    send_type: "",
  });

  const requestStatusText = {
    no_process: "Đang chờ xử lý",
    approved: "Đã xử lý thành công",
    removed: "Đã từ chối",
  };
  const requestTypeText = {
    full_name: "Thay đổi họ và tên",
    phone_number: "Thay đổi số điện thoại",
    email: "Thay đổi email",
    bank: "Thay đổi tài khoản ngân hàng",
    birthday: "Thay đổi ngày sinh",
    forget_password: "Cấp lại mật khẩu đăng nhập",
    forget_password_withdraw: "Cấp lại mật khẩu rút tiền",
  };
  const getVerificationStatusText = (status, sendType) => {
    if (status === "success") return "Đã nhận xác thực hợp lệ";
    if (status === "invalid") return sendType === "email"
      ? "Đã nhận xác thực nhưng sai địa chỉ email"
      : "Đã nhận xác thực nhưng sai số điện thoại";
    return sendType === "email" ? "Chưa nhận được email xác thực" : "Chưa nhận được SMS xác thực";
  };
  const maskRequestCode = (code = "") => {
    const value = String(code);
    return value.startsWith("xxxxxx") ? value : `xxxxxx${value.slice(-2)}`;
  };

  const refreshSubmittedRequest = async () => {
    if (isRefreshingRequest || !submittedRequest?.request_code) return;

    setIsRefreshingRequest(true);
    setRequestRefreshMessage("");

    const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
    if (result?.code === 200 && result?.data?.request) {
      const request = result.data.request;
      setSubmittedRequest((current) => ({ ...(current || {}), ...request }));
      setRecentRequests((items) => items
        .map((item) => ((item._request_code || item.request_code) === request.request_code
          ? { ...item, ...request, request_code: item.request_code }
          : item))
        .slice(0, 2));
      setRequestRefreshMessage(`Đã cập nhật trạng thái mới nhất lúc ${new Date().toLocaleTimeString("vi-VN")}`);
    } else {
      setRequestRefreshMessage("Không thể cập nhật trạng thái. Vui lòng thử lại.");
    }

    setIsRefreshingRequest(false);
  };

  const copySubmittedRequestCode = async () => {
    try {
      await navigator.clipboard.writeText(submittedRequest?.request_code || "");
      setRequestRefreshMessage(`Đã sao chép: ${submittedRequest?.request_code}`);
    } catch (error) {
      setRequestRefreshMessage("Không thể sao chép mã yêu cầu.");
    }
  };

  useEffect(() => {
    if (!openConfirm || !submittedRequest?.request_code || submittedRequest.status !== "no_process" || pollingChecks >= 15) {
      return undefined;
    }

    const immediateCheck = async () => {
      const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
      if (result?.code === 200 && result?.data?.request) {
        const request = result.data.request;
        setSubmittedRequest((current) => ({ ...(current || {}), ...request }));
        setRecentRequests((items) => items
          .map((item) => ((item._request_code || item.request_code) === request.request_code
            ? { ...item, ...request, request_code: item.request_code }
            : item))
          .slice(0, 2));
      }
    };

    immediateCheck();

    const intervalId = setInterval(async () => {
      const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
      setPollingChecks((count) => count + 1);
      if (result?.code === 200 && result?.data?.request) {
        const request = result.data.request;
        setSubmittedRequest((current) => ({ ...(current || {}), ...request }));
        setRecentRequests((items) => items
          .map((item) => ((item._request_code || item.request_code) === request.request_code
            ? { ...item, ...request, request_code: item.request_code }
            : item))
          .slice(0, 2));
      }
    }, 30 * 1000);

    return () => clearInterval(intervalId);
  }, [openConfirm, submittedRequest?.request_code, submittedRequest?.status, pollingChecks, userName]);

  const inputDataCheck = (event) => {
    let { name, value } = event.target;
    if (name === "email") {
      value = value.toLowerCase();
    }
    setDataCheck({
      ...dataCheck,
      [name]: value,
    });
  };
  
  const inputDataUpdate = (event) => {
    const { name, value } = event.target;
    setDataUpdate({
      ...dataUpdate,
      [name]: value,
    });
    if (name === "bank_type_change") {
      switch (value) {
        case "Thêm số tài khoản": setDesChangeBank(desBankNew); break;
        case "Xóa số tài khoản": setDesChangeBank(desBankRemove); break;
        case "Đổi số tài khoản": setDesChangeBank(originalDesChangeBank); break;
        default: setDesChangeBank(originalDesChangeBank);
      }
    }
    if (name === "usdt_type_change") {
      switch (value) {
        case "Thêm số tài khoản": setDesChangeUsdt(desUsdtNew); break;
        case "Xóa số tài khoản": setDesChangeUsdt(desUsdtRemove); break;
        case "Đổi số tài khoản": setDesChangeUsdt(originalDesChangeUsdt); break;
        default: setDesChangeUsdt(originalDesChangeUsdt);
      }
    }
  };
  let contentUpdate;

  useEffect(() => {
    updateUserField("update_type", typeModal)
  }, []);

  useEffect(() => {
    const fetchBanks = async () => {
      setBanks(await apiGetBanks());
    };
    fetchBanks();
  }, []);

  // chọn ngân hàng: lưu mã ngân hàng (bank_code) và tên ngân hàng (bank_name)
  const selectBankCheck = (event) => {
    const bank = banks.find((item) => item.code === event.target.value);
    setDataCheck({
      ...dataCheck,
      bank_code: bank ? bank.code : "",
      bank_name: bank ? bank.name : "",
    });
  };

  const selectBankUpdate = (event) => {
    const bank = banks.find((item) => item.code === event.target.value);
    setDataUpdate({
      ...dataUpdate,
      bank_code: bank ? bank.code : "",
      bank_name: bank ? bank.name : "",
    });
  };

  const validateForm = (sendType = "", checkData = dataCheck) => {
    let errors = {};
    let formIsValid = true;

    // Kiểm tra trường Name
    if (!checkData.name) {
      formIsValid = false;
      errors.name = 'Vui lòng nhập Họ và Tên';
    }

    // Kiểm tra trường phone_number
    if (data.phone_number && (showOldContactFields || sendType === "phone_number")) {
      if (!checkData.phone_number) {
        formIsValid = false;
        errors.phone_number = 'Vui lòng nhập Số Điện Thoại';
      } else if (!/^\d{10}$/.test(checkData.phone_number)) {
        formIsValid = false;
        errors.phone_number = 'Số Điện Thoại không hợp lệ';
      }
    }

    // Kiểm tra trường email
    if (data.email && (showOldContactFields || sendType === "mail")) {
      if (!checkData.email) {
        formIsValid = false;
        errors.email = 'Vui lòng nhập Email';
      } else if (!/\S+@\S+\.\S+/.test(checkData.email)) {
        formIsValid = false;
        errors.email = 'Email không hợp lệ';
      }
    }

    // Kiểm tra trường bank_name
    if (!checkData.bank_name) {
      formIsValid = false;
      errors.bank_name = 'Vui lòng chọn Ngân Hàng';
    }

    // Kiểm tra trường bank_number
    if (!checkData.bank_number) {
      formIsValid = false;
      errors.bank_number = 'Vui lòng nhập Số Tài Khoản';
    }
    switch (typeModal) {
      case "full_name": // Kiểm tra trường Name update
      if (!dataUpdate.name) {
        formIsValid = false;
        errors.nameUpdate = 'Vui lòng nhập Họ và Tên mới';
      } else {
        contentUpdate = dataUpdate.name;
      }
      break;
      case "phone_number":// Kiểm tra trường phone_number
        if (!dataUpdate.phone_number) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Vui lòng nhập Số Điện Thoại mới';
        } else if (!/^\d{10}$/.test(dataUpdate.phone_number)) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Số Điện Thoại mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.phone_number;
        }
        break;
      case "email":// Kiểm tra trường email
        if (!dataUpdate.email) {
          formIsValid = false;
          errors.emailUpdate = 'Vui lòng nhập Email mới';
        } else if (!/\S+@\S+\.\S+/.test(dataUpdate.email)) {
          formIsValid = false;
          errors.emailUpdate = 'Email mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.email;
        }
        break;
      case "bank":// Kiểm tra value bank
        if (!dataUpdate.bank_type_change) {
          formIsValid = false;
          errors.bankTypeChange = 'Vui lòng chọn yêu cầu thay đổi';
        }
        if (!dataUpdate.bank_name) {
          formIsValid = false;
          errors.bankNameUpdate = `Vui lòng chọn ${desChangeBank.bank_name.replace("Tên ", "")}`;
        }
        if (!dataUpdate.bank_number) {
          formIsValid = false;
          errors.bankNumberUpdate = 'Vui lòng nhập Số Tài Khoản mới';
        } else {
          contentUpdate = ( dataUpdate.bank_type_change + " - " + dataUpdate.bank_number + " - " + dataUpdate.bank_name )
        }
        break;
      case "birthday": // Kiểm tra trường birth day
        if (!dataUpdate.birth_day) {
          formIsValid = false;
          errors.birthDayUpdate = 'Vui lòng chọn ngày tháng năm sinh';
        } else {
          contentUpdate = dataUpdate.birth_day;
        }
        break;
      case "usdt":// Kiểm tra value bank
        if (!dataUpdate.bank_type_change) {
          formIsValid = false;
          errors.bankTypeChange = 'Vui lòng chọn yêu cầu thay đổi';
        }
        if (!dataUpdate.bank_name) {
          formIsValid = false;
          errors.bankNameUpdate = 'Vui lòng chọn Ví mới';
        }
        if (!dataUpdate.bank_number) {
          formIsValid = false;
          errors.bankNumberUpdate = 'Vui lòng nhập Ví mới';
        } else {
          contentUpdate = ( dataUpdate.bank_type_change + " - " + dataUpdate.bank_number + " - " + dataUpdate.bank_name )
        }
        break;
      case "forget_password":
        contentUpdate = "Lấy mật khẩu đăng nhập";
        break;
      case "forget_password_withdraw":
        contentUpdate = "Lấy mật khẩu rút tiền";
        break;
      case "other_note":
        if (!dataUpdate.other_note) {
          formIsValid = false;
          errors.other_note = 'Vui lòng điền nội dung muốn gửi';
        } else {
          contentUpdate = dataUpdate.other_note;
        }
        break;
      default: break
    }
    console.log(errors)
    setErrors(errors);
    return formIsValid;
  };
  const modalConfirmUpdate = async (type) => {
    if (showOldContactFields) {
      const nextDataCheck = {
        ...dataCheck,
        email: dataCheck.email.trim().toLowerCase(),
        phone_number: dataCheck.phone_number.trim().replace(/^(\+?84)/, "0"),
      };
      setDataCheck(nextDataCheck);
      await updateUser(type, undefined, nextDataCheck);
      return;
    }
    if (type === "files") {
      if (validateForm(type)) {
        user.send_type = "files";
        updateUserField("send_type", "files");
        updateUser("files");
      }
      return;
    }

    if (!validateForm("files")) {
      return;
    }

    const isEmail = type === "mail";
    const result = await Swal.fire({
      icon: "warning",
      title: isEmail
        ? "Vui lòng nhập Email đã liên kết"
        : "Vui lòng nhập Số Điện Thoại đã liên kết",
      input: isEmail ? "email" : "text",
      inputValue: isEmail ? dataCheck.email : dataCheck.phone_number,
      inputPlaceholder: isEmail ? "Email" : "Số Điện Thoại",
      showCancelButton: true,
      confirmButtonText: "Tiếp tục",
      cancelButtonText: "Quay lại",
      reverseButtons: true,
      inputValidator: (value) => {
        const normalizedValue = isEmail
          ? value.trim().toLowerCase()
          : value.trim().replace(/^(\+?84)/, "0");

        if (!normalizedValue) {
          return isEmail
            ? "Vui lòng nhập Email"
            : "Vui lòng nhập Số Điện Thoại";
        }
        if (isEmail && !/\S+@\S+\.\S+/.test(normalizedValue)) {
          return "Email không hợp lệ";
        }
        if (!isEmail && !/^\d{10}$/.test(normalizedValue)) {
          return "Số Điện Thoại không hợp lệ";
        }
        return undefined;
      },
    });

    if (result.isConfirmed) {
      const value = isEmail
        ? result.value.trim().toLowerCase()
        : result.value.trim().replace(/^(\+?84)/, "0");
      const nextDataCheck = {
        ...dataCheck,
        [isEmail ? "email" : "phone_number"]: value,
      };
      setDataCheck(nextDataCheck);
      updateUser(type, undefined, nextDataCheck);
    }
  };
  const updateUserField = (field, value) => {
    setUser((prevUser) => ({
      ...prevUser,
      [field]: value,
    }));
  };
  
  const openModalConfirm = (type) => {
    setOpenConfirm(true);
  };
  const confirmUpdateUser = async (body, type) => {
    setLoading(true);
    const updateInfo = await apiFormUpdateAccount(body, selectedFiles);
    setLoading(false);

    const newRequestCode = updateInfo?.request_code;
    if (newRequestCode) {
      const newRequest = {
        ...body,
        request_code: newRequestCode,
        _request_code: newRequestCode,
        status: "no_process",
        verification_status: ["email", "phone_number"].includes(body.send_type) ? "not_received" : "success",
        createdAt: new Date().toISOString(),
      };
      setUser((currentUser) => ({ ...currentUser, request_code: newRequestCode }));
      setSubmittedRequest(newRequest);
      setRecentRequests((items) => [{ ...newRequest, request_code: `xxxxxx${newRequestCode.slice(-2)}` }, ...items].slice(0, 2));
      setPollingChecks(0);
      setRequestRefreshMessage("");
      openModalConfirm(type);
    }
  };
  const updateUser = async (type, submit, checkData = dataCheck) => {
    if (validateForm(type, checkData)) {
      if (type === "mail") {
        user.send_type = 'email';
        setIsSendMail(true);
      } else if (type === "phone_number") {
        user.send_type = 'phone_number';
        setIsSendMail(false);
      } else if (type === "files") {
        user.send_type = 'files';
        updateUserField('send_type', 'files')
        setIsSendMail(false);
      }
      let body = {
        ...user,
        data_check: {
          ...checkData,
        },
        data_update: {
          update_type: user.update_type,
          content: contentUpdate,
          // đổi ngân hàng: gửi thêm mã ngân hàng + số tài khoản để BE không phải tách từ content
          ...(user.update_type === "bank" && {
            bank_code: dataUpdate.bank_code,
            bank_number: dataUpdate.bank_number,
          }),
        }
      };
      setLoading(true)
      let checkDataOld = await apiCheckDataAccount(body);
      setLoading(false)
      if (checkDataOld) {
        if (type === "files" && !submit) {
          let descriptionFileUpload = uploadDescriptions.length > 0
            ? "<span>Bạn vui lòng tải lên ít nhất " + minFiles + " trong " + uploadDescriptions.length + " hình ảnh dưới để xác minh tài khoản<br/><br/></span>"
            : "Bạn vui lòng tải lên ít nhất " + minFiles + " hình ảnh để xác minh tài khoản<br/><br/>";
          uploadDescriptions.forEach((element, index) => {
            descriptionFileUpload += (index + 1) + ". " + element + "</br>";
          });
          descriptionFileUpload = "<p>" + descriptionFileUpload + "</p>";
          setInfoFileUpload(descriptionFileUpload)
          setOpenUploadFile(true);
          return;
        }
        let confirmUpdate = checkDataOld.result;
        let value_auto_check = confirmUpdate ? "check_success" : "check_fail";
        updateUserField("auto_check", value_auto_check);
        body.auto_check = value_auto_check;
        if (type === "mail" || type === "phone_number") {
          const isEmail = type === "mail";
          const canSubmit = isEmail
            ? checkDataOld.submitEmail === 1
            : checkDataOld.submitPhoneNumber === 1;

          if (canSubmit) {
            await confirmUpdateUser(body, type);
          } else {
            const result = await Swal.fire({
              icon: "warning",
              title: "Chú ý",
              text: isEmail
                ? "Quý khách nhập không đúng Email liên kết, vui lòng kiểm tra lại thông tin hoặc sử dụng cách khác."
                : "Quý khách nhập không đúng SĐT đã liên kết, vui lòng kiểm tra lại thông tin hoặc sử dụng cách khác.",
              showCancelButton: true,
              cancelButtonText: "Nhập lại",
              showConfirmButton: false,
            });
            if (result.dismiss === Swal.DismissReason.cancel && !showOldContactFields) {
              modalConfirmUpdate(type);
            }
          }
          return;
        }
        //nếu thông tin đúng hết hoặc đã nhập lại từ 5 lần và có số điện thoại hoặc email đúng thì tự động confirm gửi yêu cầu
        if (confirmUpdate || (timesCheckData >= 100 && checkDataOld.allowSubmit >0)) {
          confirmUpdateUser(body, type);
        } else {
          setLoading(false)
          Swal.fire({
            icon: (checkDataOld.countMatch / checkDataOld.count < 0.5) ? "error" : "warning",
            title: "Chú ý",
            text: (checkDataOld.allowSubmit === 0 && type !== 'files') ? "Sai số điện thoại và email liên kết" : "Thông tin cũ bạn nhập đúng " + Math.round(checkDataOld.countMatch / checkDataOld.count * 100) + "%",
            showCancelButton: true,
            cancelButtonText: 'Quay về chỉnh sửa',
            confirmButtonText: 'Tiếp tục gửi',
            // chỉ khi có ít nhất 1 thông tin (số điện thoại hoặc email) đúng hoặc phương thức xác thực hình ảnh thì mới hiển thị nút confirm gửi yêu cầu
            showConfirmButton: (type === 'files' || checkDataOld.allowSubmit > 0),
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
              confirmUpdateUser(body, type);
            } else if (result.isDismissed) {
              setTimesCheckData(timesCheckData + 1)
            }
          });
        }
      }
    }
  };
  const closeModalConfirm = () => {
    setOpenConfirm(false);
    navigate("/profile", { state: { userName, data: { ...data, recent_requests: recentRequests }, webSetting } });
  };

  const handleMediaUpload = async (event) => {
    const files = Array.from(event.target.files);
    const validFiles = files.filter((file) => {
      if (file.size > 50 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Thất bại!",
          text: `File ${file.name} vượt quá giới hạn 50MB.`,
        });
        return false;
      }
      return true;
    });
    
    event.target.value = ""; // cho phép chọn lại cùng 1 file sau khi xóa
    // kiểm tra tối đa 7 file trước khi thêm vào danh sách gửi
    if (previews.length + validFiles.length > 7) {
      Swal.fire({
        icon: "error",
        title: "Thất bại!",
        text: "Hệ thống yêu cầu tối đa 7 file",
      });
      return;
    }
    // kiểm tra tổng dung lượng các file gửi lên tối đa 50MB
    const totalSize = [...selectedFiles, ...validFiles].reduce((total, file) => total + file.size, 0);
    if (totalSize > 70 * 1024 * 1024) {
      Swal.fire({
        icon: "error",
        title: "Thất bại!",
        text: "Tổng dung lượng các file vượt quá giới hạn 50MB.",
      });
      return;
    }
    setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    const newPreviews = validFiles.map((file) => ({
      url: URL.createObjectURL(file),
      type: file.type.startsWith("image") ? "image" : "video"
    }));
    const base64Images = await Promise.all(
      validFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
        });
      })
    );
    setPreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);
    setSelectedImage((prevImages) => [...prevImages, ...base64Images]);
  };

  const handleRemoveImage = (index) => {
    setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    setSelectedImage((prevImages) => prevImages.filter((_, i) => i !== index));
    // xóa cả file sẽ gửi lên, không chỉ ảnh xem trước
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  return (
    <div className="container">
    {(loading) && (
      <Loading loading={loading}/>
    )}
      <motion.div
        className="app"
        initial={{ x: "100vw", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: "-100vw", opacity: 0 }}
        transition={{ type: "spring", stiffness: 1000, damping: 200, duration: 10 }}
      >
        <Header isPageSearch={false} pageToAcction={"/profile"} data={ {userName, data, webSetting} } currentPage={typeModal}/>

        <div className="content">
          {/* <Popup open={open} onClose={() => {setOpen(false); document.body.style.overflow = 'auto';}} position={"center"} closeOnDocumentClick={false} nested> */}
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} id="modal-info" className="modal-info">
              {/* <div className="info-current">
                <Collapsible open={false} trigger={["THÔNG TIN CÁ NHÂN", <img src={iconArrow} key="icon-arrow" alt="icon-arrow" />]}>
                  <InfoUser />
                </Collapsible>
              </div> */}
              <div className="confirm-info-old" style={{ textAlign: "left", margin:"0 15px" }}>
                <span className="modal-titlte">VUI LÒNG NHẬP LẠI THÔNG TIN ĐÃ LIÊN KẾT</span>
                <div className="input-info">
                  <input type="text" name="name" value={dataCheck.name} onChange={inputDataCheck} placeholder="Họ Và Tên" />
                  {errors.name && <p className="error">{errors.name}</p>}
                  {showOldContactFields && <>
                    <input type="text" name="phone_number" value={dataCheck.phone_number} onChange={inputDataCheck} placeholder="Số Điện Thoại" />
                    {errors.phone_number && <p className="error">{errors.phone_number}</p>}
                    <input type="text" name="email" value={dataCheck.email} onChange={inputDataCheck} placeholder="Email" />
                    {errors.email && <p className="error">{errors.email}</p>}
                  </>}
                  <select name="bank_code" value={dataCheck.bank_code || ""} onChange={selectBankCheck}>
                    <option value="">Chọn Ngân Hàng</option>
                    {banks.map((bank) => (
                      <option key={bank.code} value={bank.code}>
                        {bank.name}
                      </option>
                    ))}
                  </select>
                  {errors.bank_name && <p className="error">{errors.bank_name}</p>}
                  <input type="text" name="bank_number" value={dataCheck.bank_number} onChange={inputDataCheck} placeholder="Số Tài Khoản" />
                  {errors.bank_number && <p className="error">{errors.bank_number}</p>}
                </div>
              </div>
              <div className="confirm-info-new" style={{ textAlign: "left", margin:"0 15px" }}>
                {
                  {
                    "full_name": 
                    <>
                      <span className="modal-titlte" style={{ textAlign: "center" }}>THAY ĐỔI HỌ TÊN MỚI</span>
                      <div className="input-info">
                        <input type="text" name="name" onChange={inputDataUpdate} placeholder="Họ Tên Mới" />
                        {errors.nameUpdate && <p className="error">{errors.nameUpdate}</p>}
                      </div>
                    </>,
                    "phone_number": 
                    <>
                      <span className="modal-titlte" style={{ textAlign: "center" }}>THAY ĐỔI SỐ ĐIỆN THOẠI MỚI</span>
                      <div className="input-info">
                        <input type="text" name="phone_number" onChange={inputDataUpdate}  placeholder="Số Điện Thoại Mới" />
                        {errors.phoneNumberUpdate && <p className="error">{errors.phoneNumberUpdate}</p>}
                      </div>
                    </>,
                    "email": 
                    <>
                      <span className="modal-titlte" style={{ textAlign: "center" }}>THAY ĐỔI EMAIL MỚI</span>
                      <div className="input-info">
                        <input type="text" name="email" onChange={inputDataUpdate} placeholder="Email Mới" />
                        {errors.emailUpdate && <p className="error">{errors.emailUpdate}</p>}
                      </div>
                    </>,
                    "bank": 
                    <>
                      <span className="modal-titlte" style={{ textAlign: "center" }}>{desChangeBank.title_change_bank}</span>
                      <div className="input-info">
                        <select type="input" name="bank_type_change" onChange={inputDataUpdate}>
                          <option value="">Chọn yêu cầu thay đổi</option>
                          {config.LIST_REQUEST_BANK.map((bank, index) => (
                            <option key={index} value={bank}>
                              {bank}
                            </option>
                          ))}
                        </select>
                        {errors.bankTypeChange && <p className="error">{errors.bankTypeChange}</p>}
                        <select name="bank_code" value={dataUpdate.bank_code || ""} onChange={selectBankUpdate}>
                          <option value="">{`Chọn ${desChangeBank.bank_name.replace("Tên ", "")}`}</option>
                          {banks.map((bank) => (
                            <option key={bank.code} value={bank.code}>
                              {bank.name}
                            </option>
                          ))}
                        </select>
                        {errors.bankNameUpdate && <p className="error">{errors.bankNameUpdate}</p>}
                        <input type="text" name="bank_number" onChange={inputDataUpdate} placeholder={desChangeBank.bank_number} />
                        {errors.bankNumberUpdate && <p className="error">{errors.bankNumberUpdate}</p>}
                      </div>
                    </>,
                    "birthday":
                    <div className="input-info">
                      <input type="date" name="birth_day" onChange={inputDataUpdate} placeholder="ngày tháng năm sinh" defaultValue="2000-12-01"/>
                      {errors.birthDayUpdate && <p className="error">{errors.birthDayUpdate}</p>}
                    </div>,
                    "usdt": 
                    <>
                      <span className="modal-titlte" style={{ textAlign: "center" }}>{desChangeUsdt.title_change_bank}</span>
                      <div className="input-info">
                        <select type="input" name="bank_type_change" onChange={inputDataUpdate}>
                          <option value="">Chọn yêu cầu thay đổi</option>
                          {config.LIST_REQUEST_USDT.map((bank, index) => (
                            <option key={index} value={bank}>
                              {bank}
                            </option>
                          ))}
                        </select>
                        {errors.bankTypeChange && <p className="error">{errors.bankTypeChange}</p>}
                        <select name="bank_name" value={dataUpdate.bank_name} onChange={inputDataUpdate}>
                          {config.LIST_USDT_WALLET.map((wallet, index) => (
                            <option key={index} value={wallet}>
                              {wallet}
                            </option>
                          ))}
                        </select>
                        {errors.bankNameUpdate && <p className="error">{errors.bankNameUpdate}</p>}
                        <input type="text" name="bank_number" onChange={inputDataUpdate} placeholder={desChangeUsdt.bank_number} />
                        {errors.bankNumberUpdate && <p className="error">{errors.bankNumberUpdate}</p>}
                      </div>
                    </>,
                    "forget_password":
                    <span className="modal-titlte">CẤP LẠI MẬT KHẨU ĐĂNG NHẬP</span>,
                    "forget_password_withdraw":
                    <span className="modal-titlte">CẤP LẠI MẬT KHẨU RÚT TIỀN</span>,
                    "other_note":
                    <>
                      <span className="modal-titlte" style={{ textAlign: "center" }}>NỘI DUNG CẦN HỖ TRỢ</span>
                      <div className="input-info">
                        <textarea
                          name="other_note"
                          onChange={inputDataUpdate}
                          placeholder="Nhập nội dung cần hỗ trợ..."
                          rows={5}          // số dòng hiển thị ban đầu
                        />
                        {errors.other_note && (
                          <p className="error">{errors.other_note}</p>
                        )}
                      </div>
                    </>,
                  }[typeModal]
                }
              </div>
              <div className="mode-verify" style={{ textAlign: "left" }}>
                <span className="modal-titlte" style={{ textAlign: "left" }}>VUI LÒNG LỰA CHỌN HÌNH THỨC GỬI XÁC THỰC</span>
                {(typeModal !== "birthday" && typeModal !== "other_note") &&
                <>
                  <div className="action action-verify">
                    { data.email &&
                    <button onClick={() => modalConfirmUpdate("mail")} className="action-verify-btn">
                      <img src={iconSendMail} alt="icon-email" />
                      &nbsp; XÁC THỰC EMAIL
                    </button>
                    }
                    {(data.phone_number && webSetting.phone_number) &&
                    <button onClick={() => modalConfirmUpdate("phone_number")} className="action-verify-btn">
                      <img src={iconSendPhone} alt="icon-phone" />
                      &nbsp; XÁC THỰC SĐT
                    </button>
                    }
                  </div>
                  <p className='note-verify-image'>
                    Nếu quý khách không có email hoặc SĐT để gửi thông tin, vui lòng nhấn nút dưới đây để thực hiện thay thế
                  </p>
                </>
                }
                <div className="action action-verify">
                  <button className="action-verify-btn action-verify-btn-img" onClick={() => modalConfirmUpdate("files")}>
                    <img src={iconImage} alt="icon-bank" />
                      &nbsp; TẢI LÊN HÌNH ẢNH THAY THẾ XÁC THỰC
                  </button>
                </div>
              </div>
            </motion.div>
          {/* </Popup> */}
          <Popup open={openConfirm} closeOnDocumentClick={false} onClose={closeModalConfirm} position={"center"} nested>
            <motion.div
              initial={{ opacity: 0, y: 75 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              id="modal-confirm"
              className="modal-confirm"
            >
              {/* <div className="modal-close">
                <button type="button" className="icon-close" onClick={closeModalConfirm} aria-label="Đóng popup xác nhận">
                  <img src={iconClose} alt="icon-close" />
                </button>
              </div> */}
                {user.send_type === 'files' ? (
                  <div className="modal-confirm-content">
                    <img style={{ marginBottom: "20px" }} src={iconSuccess} alt="icon-success" />
                    <span>Yêu cầu của quý khách đã được ghi nhận. Vui lòng giữ màn hình mở để theo dõi tiến độ xử lý.</span>
                    <div className="btn-wrapper-home">
                      <div className="btn-send btn-home">
                          <a href={ webSetting.link_home }
                              target="_blank"
                              rel="noopener noreferrer">VỀ TRANG CHỦ
                          </a>
                      </div>
                    </div>
                    {submittedRequest && (
                      <div className={`request-processing-status status-${submittedRequest.status} verification-${["email", "phone_number"].includes(submittedRequest.send_type) ? submittedRequest.verification_status || "not_received" : "success"}`}>
                        {submittedRequest.status === "no_process" && (
                          <div className={`request-live-update-notice ${pollingChecks >= 15 ? "request-live-update-stopped" : ""}`} role="status" aria-live="polite">
                            {pollingChecks < 15 ? <span className="request-loading-icon" aria-hidden="true" /> : <span className="request-update-paused-icon" aria-hidden="true">✓</span>}
                            <div>
                              <strong>{pollingChecks < 15 ? "Hệ thống đang tự động cập nhật trạng thái" : ""}</strong>
                              <small>{pollingChecks < 15 ? "Vui lòng giữ màn hình hoặc sao chép mã yêu cầu để tra soát lại kết quả." : "Bạn có thể bấm Kiểm tra lại để lấy trạng thái mới nhất."}</small>
                            </div>
                          </div>
                        )}
                        <strong className="request-processing-title">
                          {submittedRequest.status === "approved"
                            ? "Yêu cầu đã được xử lý thành công"
                            : submittedRequest.status === "removed"
                              ? "Yêu cầu đã bị từ chối"
                              : pollingChecks < 15 ? "Yêu cầu đang được xử lý" : "Yêu cầu đang được xử lý lâu hơn dự kiến"}
                        </strong>
                        <p className="submitted-request-code">Mã yêu cầu: <strong>{submittedRequest.request_code}</strong></p>
                        {(submittedRequest.note || submittedRequest.result) && (
                          <div className="request-result-note">
                            <strong>Kết quả xử lý:</strong>
                            <HtmlNote html={submittedRequest.note || submittedRequest.result} />
                          </div>
                        )}
                        <div className="request-progress">
                          <div className="request-progress-step step-complete"><span>1</span><small>Đã gửi yêu cầu</small></div>
                          <div className="request-progress-step step-complete"><span>2</span><small>Đã tiếp nhận</small></div>
                          <div className={`request-progress-step ${submittedRequest.status === 'approved' ? 'step-complete' : submittedRequest.status === 'removed' ? 'step-error' : 'step-current'}`}><span>3</span><small>Đang xử lý</small></div>
                          <div className={`request-progress-step ${submittedRequest.status === 'approved' ? 'step-complete' : submittedRequest.status === 'removed' ? 'step-error' : 'step-pending'}`}><span>4</span><small>Hoàn tất</small></div>
                        </div>
                        {submittedRequest.status === "no_process" && (
                          <div className="request-processing-message">
                            <p>Yêu cầu của quý khách đã được ghi nhận. Vui lòng giữ màn hình mở để theo dõi tiến độ.</p>
                            {pollingChecks >= 15 && (
                              <>
                                <p>Yêu cầu đang xử lý lâu hơn dự kiến.</p>
                                <div className="request-processing-actions">
                                  <button type="button" onClick={refreshSubmittedRequest} disabled={isRefreshingRequest}>{isRefreshingRequest ? "Đang kiểm tra..." : "Kiểm tra lại"}</button>
                                  <button type="button" onClick={copySubmittedRequestCode}>Sao chép mã</button>
                                  <a href={webSetting?.link_home || "/"} target="_blank" rel="noopener noreferrer">Về trang chủ</a>
                                </div>
                              </>
                            )}
                            {requestRefreshMessage && <p className="request-refresh-message" role="status">{requestRefreshMessage}</p>}
                          </div>
                        )}
                      </div>
                    )}
                    <div className="notification">
                      <p>- Liên hệ <a href={ webSetting.link_cskh }
                        target="_blank"
                        rel="noopener noreferrer">CSKH</a> nếu cần hỗ trợ thêm.</p>
                  </div>
                  </div>
                ): (
              <div className="modal-confirm-content">
                <img className="icon-warning" src={iconWarning} alt="icon-warning" />
                {isSendMail ? (
                  <p>
                    Vui lòng sử dụng email đã liên kết <span style={{ color: "green" }}>{data.email}</span>, gửi nội dung xác thực tới email ON68{" "}
                    <span style={{ color: "red" }}>{ webSetting.email }</span>.
                  </p>
                ) : user.send_type === 'phone_number' ? (
                  <p>
                    Vui lòng sử dụng số điện thoại đã liên kết <span style={{ color: "green" }}>{data.phone_number}</span>, gửi nội dung xác thực tới số điện thoại ON68{" "}
                    <span style={{ color: "red" }}>{ webSetting.phone_number }</span>.
                  </p>
                ) : (
                  <p>
                    Yêu cầu của quý khách đã được ghi nhận. Vui lòng giữ màn hình mở để theo dõi tiến độ xử lý.
                  </p>
                )}
                <DataConfirm user={user}
                dataCheck = {dataCheck}
                dataUpdate = {dataUpdate}
                webSetting = {webSetting}/>
                {submittedRequest && (
                  <div className={`request-processing-status status-${submittedRequest.status} verification-${["email", "phone_number"].includes(submittedRequest.send_type) ? submittedRequest.verification_status || "not_received" : "success"}`}>
                    {submittedRequest.status === "no_process" && (
                      <div className={`request-live-update-notice ${pollingChecks >= 15 ? "request-live-update-stopped" : ""}`} role="status" aria-live="polite">
                        {pollingChecks < 15 ? <span className="request-loading-icon" aria-hidden="true" /> : <span className="request-update-paused-icon" aria-hidden="true">✓</span>}
                        <div>
                          <strong>{pollingChecks < 15 ? "Hệ thống đang tự động cập nhật trạng thái" : ""}</strong>
                          <small>{pollingChecks < 15 ? "Vui lòng giữ màn hình hoặc sao chép mã yêu cầu để tra soát lại kết quả." : "Bạn có thể bấm Kiểm tra lại để lấy trạng thái mới nhất."}</small>
                        </div>
                      </div>
                    )}
                    <strong className="request-processing-title">
                      {submittedRequest.status === "approved"
                        ? "Yêu cầu đã được xử lý thành công"
                        : submittedRequest.status === "removed"
                          ? "Yêu cầu đã bị từ chối"
                          : ["email", "phone_number"].includes(submittedRequest.send_type) && submittedRequest.verification_status !== "success"
                            ? "Yêu cầu đang chờ xác thực"
                            : pollingChecks < 15 ? "Yêu cầu đang được xử lý" : "Yêu cầu đang được xử lý lâu hơn dự kiến"}
                    </strong>
                    <p className="submitted-request-code">
                      Mã yêu cầu: <strong>{submittedRequest.request_code}</strong>
                    </p>
                    {(submittedRequest.note || submittedRequest.result) && (
                      <div className="request-result-note">
                        <strong>Kết quả xử lý:</strong>
                        <HtmlNote html={submittedRequest.note || submittedRequest.result} />
                      </div>
                    )}
                    <div className="request-progress">
                      <div className="request-progress-step step-complete"><span>1</span><small>Đã gửi yêu cầu</small></div>
                      <div className={`request-progress-step ${!['email', 'phone_number'].includes(submittedRequest.send_type) || submittedRequest.verification_status === 'success' ? 'step-complete' : submittedRequest.verification_status === 'invalid' ? 'step-error' : 'step-current'}`}><span>2</span><small>{['email', 'phone_number'].includes(submittedRequest.send_type) ? 'Xác thực' : 'Đã tiếp nhận'}</small></div>
                      <div className={`request-progress-step ${submittedRequest.status === 'approved' ? 'step-complete' : submittedRequest.status === 'removed' ? 'step-error' : ['email', 'phone_number'].includes(submittedRequest.send_type) && submittedRequest.verification_status !== 'success' ? 'step-pending' : 'step-current'}`}><span>3</span><small>Đang xử lý</small></div>
                      <div className={`request-progress-step ${submittedRequest.status === 'approved' ? 'step-complete' : submittedRequest.status === 'removed' ? 'step-error' : 'step-pending'}`}><span>4</span><small>Hoàn tất</small></div>
                    </div>
                    {submittedRequest.status === "no_process" && (
                      <div className="request-processing-message">
                        {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "email" && <p>Chưa nhận xác thực. Vui lòng gửi từ email đã liên kết.</p>}
                        {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "phone_number" && <p>Chưa nhận xác thực. Vui lòng gửi từ số điện thoại đã liên kết.</p>}
                        {submittedRequest.verification_status === "invalid" && <p>Xác thực không hợp lệ. Vui lòng kiểm tra thông tin và gửi lại.</p>}
                        {pollingChecks >= 15 && (
                          <>
                            <p>Yêu cầu đang xử lý lâu hơn dự kiến.</p>
                            <div className="request-processing-actions">
                              <button type="button" onClick={refreshSubmittedRequest} disabled={isRefreshingRequest}>{isRefreshingRequest ? "Đang kiểm tra..." : "Kiểm tra lại"}</button>
                              <button type="button" onClick={copySubmittedRequestCode}>Sao chép mã</button>
                              {/* <a href={webSetting?.link_home || "/"} target="_blank" rel="noopener noreferrer">Về trang chủ</a> */}
                            </div>
                          </>
                        )}
                        {requestRefreshMessage && <p className="request-refresh-message" role="status">{requestRefreshMessage}</p>}
                      </div>
                    )}
                  </div>
                )}
                <div className="notification">
                  <p>- Liên hệ <a href={ webSetting.link_cskh }
                    target="_blank"
                    rel="noopener noreferrer">CSKH</a> nếu cần hỗ trợ thêm.</p>
              </div>
              </div>
              )}
            </motion.div>
          </Popup>
          <Popup open={openResult} onClose={() => setOpenResult(false)} position={"center"}>
            <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="modal-success">
              <div className="modal-close">
                <button type="button" className="icon-close" onClick={() => setOpenResult(false)} aria-label="Đóng popup kết quả">
                  <img src={iconClose} alt="icon-close" />
                </button>
              </div>
              {checkConfirm ? (
                <div className="modal-result-content">
                  <img style={{ marginBottom: "20px" }} src={iconSuccess} alt="icon-success" />
                  <span>Chúng tôi đã nhận được yêu cầu của Quý khách, vui lòng chờ 2-5 phút và nhận kết quả phản hồi tại Hòm thư nội bộ</span>
                </div>
                ) : (
                <div className="modal-result-content">
                  <img style={{ marginBottom: "20px" }} src={iconWarning} alt="icon-success" />
                  <span>Yêu cầu của bạn chưa được ghi nhận, vui lòng thử lại hoặc liên hệ chăm sóc khách hàng</span>
                </div>
              )}
            </motion.div>
          </Popup>
          <Popup open={openUploadFile} onClose={() => setOpenUploadFile(false)} position={"center"}>
            <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="modal-success">
              <div className="modal-close">
                <button type="button" className="icon-close" onClick={() => setOpenUploadFile(false)} aria-label="Đóng popup upload">
                  <img src={iconClose} alt="icon-close" />
                </button>
              </div>
                <div className="modal-result-content">
                  <img style={{ marginBottom: "5px", height: "60px" }} src={iconWarning} alt="icon-success"/>
                  {/* <span>Bạn cần cung cấp thêm hình ảnh/video để xác minh thông tin.</span> */}
                  
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      color: "black",
                      marginBottom: "-10px",
                      marginTop: "-15px",
                      fontWeight: "bold",
                    }}
                  >
                    <div className='upload-file' dangerouslySetInnerHTML={{ __html: infoFileUpload }}/>
                  </Typography>
                  <Box
                    display="flex"
                    alignItems="center"
                    marginY={1}
                    flexWrap="wrap"
                    gap="8px 8px"
                  >
                    {previews.map((preview, index) => (
                      
                      <Box
                        onClick={() => handleRemoveImage(index)}
                        key={index}
                        sx={{
                          maxHeight: 80,
                          maxWidth: 90,
                          width: "auto",
                          height: "auto",
                          position: "relative",
                          overflow: "hidden",
                          cursor: "pointer",
                          "&:hover .delete-button": {
                            display: "block",
                          },
                        }}
                      >
                        {console.log("preview", preview)}
                      {preview.type === "image" ? (
                        <img
                          src={preview.url}
                          alt={`preview-${index}`}
                          style={{
                            width: "auto",
                            maxWidth: "100%",
                            height: "auto",
                            maxHeight: "100%",
                            borderRadius: 4,
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <video
                          src={preview.url}
                          controls
                          style={{
                            width: "auto",
                            maxWidth: "100%",
                            height: "auto",
                            maxHeight: "100%",
                            borderRadius: 4,
                            objectFit: "cover",
                          }}
                        />
                      )}
                        <IconButton
                          className="delete-button"
                          sx={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            color: "red",
                            p: 0,
                          }}
                        >
                          <Close fontSize="small" />
                        </IconButton>
                      </Box>
                    ))}
                    
                    <Box>
                      <input
                        accept="image/*, video/*"
                        style={{ display: "none" }}
                        id="upload-button"
                        type="file"
                        onChange={handleMediaUpload}
                        multiple
                      />
                      <label htmlFor="upload-button">
                        <Button
                          variant="outlined"
                          component="span"
                          startIcon={
                            <AddPhotoAlternateOutlined
                              sx={{ fontSize: "large" }}
                            />
                          }
                          sx={{
                            width: "90px",
                            height: "80px",
                            color: "#F26522",
                            borderColor: "#F26522",
                            borderStyle: "solid",
                            "&:hover": {
                              borderColor: "#F26522",
                              color: "#F26522",
                            },
                          }}
                        >
                          Thêm
                        </Button>
                      </label>
                    </Box>
                  </Box>
                  <Typography variant="caption" sx={{ color: "#B0B3C1" }}>
                    Cung cấp hình ảnh/video đúng theo mô tả để được xét duyệt <br /> (Hình ảnh/video mỗi file không vượt quá 50MB, tổng không vượt quá 50MB)
                  </Typography>
                  {selectedImage.length >= minFiles && (
                    <div>
                      <button id="complete_files_btn" onClick={() => {setOpenUploadFile(false); updateUser(user.send_type, true)}}>
                        Hoàn thành xác minh
                      </button>
                    </div>
                  )}
                </div>
            </motion.div>
          </Popup>
        </div>
      </motion.div>
    </div>
  );
}

export default ChangeInfo;
